import { MappingControl } from "../MappingControl";
import { DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMappingVendors extends Layout {
    labelGooglePlacesOptions: Label;
    labelMappingOptions: Label;
    labelTripManagement: Label;
    layoutMappingControl: MappingControl;
    panelGoogle: Panel;
    panelTrimble: Panel;
    sourceDispatchControl: DataSource;
    sourceDistanceSource: DataSource;
    sourceMappingControl: DataSource;
    sourceMappingVendor: DataSource;
    sourceWwwControl: DataSource;
    switchAllowDuplicateLocationCreationGooglePlaces: Switch;
    switchCreateLocationFromStopGooglePlaces: Switch;
    switchDisplayWeather: Switch;
    switchEnableAddCustomerGooglePlaces: Switch;
    switchEnableAddLocationGooglePlaces: Switch;
    switchEnableAddStopGooglePlaces: Switch;
    switchEnableGooglePlaces: Switch;
    switchTrafficG: Switch;
    switchTrafficT: Switch;
    switchTripManagementActive: Switch;
    textboxAlkMapApi1: Textbox;
    textboxApiKeyTrip: Textbox;
    textboxCompanyId: Textbox;
    textboxDistanceProfile: Textbox;
    textboxGoogleApiKey: Textbox;
    textboxGooglePlacesEntryDelay: Textbox;
    textboxMapViewG: Textbox;
    textboxMapViewT: Textbox;
    textboxOutOfCorridorUrl: Textbox;
    textboxPosUpdateMinutes: Textbox;
    textboxUrl: Textbox;
    textboxVersion: Textbox;
    textboxWeatherUrl: Textbox;
    textboxWebApiKey: Textbox;
}
